module.exports = __webpack_public_path__ + "img/grid_layout_2_3.27784f55.svg";